import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enGB from '@/locales/en-GB.json';
import esES from '@/locales/es-ES.json';

Vue.use(VueI18n);

export const DEFAULT_LOCALE = 'en-GB';
export const SUPPORTED_LOCALES = ['en-GB', 'es-ES'];
export const STORAGE_KEY = 'sme-portal-locale';

// Before login, use the device's stored locale preference (if present),
// regardless of company config, so login pages render properly.
export const resolveStoredLocale = storedLocale =>
  SUPPORTED_LOCALES.includes(storedLocale) ? storedLocale : DEFAULT_LOCALE;

// Once logged in, keep honouring the device preference unless the localization
// flag is off — in that case, use en-GB.
export const resolveActiveLocale = (isEnabled, storedLocale) =>
  isEnabled ? resolveStoredLocale(storedLocale) : DEFAULT_LOCALE;

const i18n = new VueI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: { 'en-GB': enGB, 'es-ES': esES },
  silentFallbackWarn: true, // missing keys fall back to en-GB
});

export default i18n;
